{
  "headings": {
    "feedback": "Ge feedback",
    "givenFeedback": "Given feedback",
    "feedbackDetail": "Feedbackinformation",
    "feedbackPreview": "Förhandsvisning av feedback",
    "preview": "Förhandsvisning",
    "success": "Feedback"
  },
  "texts": {
    "instructions": "Delta i utvecklingen, dela dina idéer!\n\nVi vill förbättra vår verksamhet och dina insikter är viktiga för oss. Dela dina erfarenheter, idéer eller utvecklingsförslag med detta formulär.",
    "success": "Din feedback har skickats. Tack för din feedback!",
    "expectsResponseInstructions": "Vill du ha ett svar på din feedback? Om du önskar få ett svar, vänligen nämn det i ditt meddelande. På så sätt kan vi säkerställa att vi återkommer till dig så smidigt som möjligt.",
    "contactDetailsUpdateInstructions": "Om det behövs kan du uppdatera dina kontaktuppgifter här. Du kan också redigera dem via sidan Mina uppgifter."
  },
  "placeholders": {
    "title": "Titel",
    "description": "Berätta mer om vad feedbacken gäller"
  },
  "alt": {
    "successIllustration": "Tack illustration"
  },
  "labels": {
    "title": "Titel",
    "description": "Beskrivning",
    "files": "Bilagor",
    "email": "E-post",
    "phoneNumber": "Telefon",
    "expectsResponse": "Jag vill bli kontaktad"
  },
  "actions": {
    "back": "Tillbaka",
    "resetForm": "Rensa formulär",
    "sendForm": "Skicka feedback",
    "preview": "Förhandsgranska",
    "edit": "Redigera",
    "submit": "Skicka"
  },
  "errors": {
    "submitError": "Fel vid skickande av feedback. Om problemet kvarstår, kontakta kundservice.",
    "serviceUnavailable": "Feedback skapande är inte tillgängligt för tillfället. Försök igen senare.",
    "noFeedbackFound": "Ingen feedback hittades.",
    "missingUserPhoneNumber": {
      "title": "Tyvärr gick det inte att skapa feedback",
      "message": "För att kunna fortsätta med din feedback, lägg till ditt telefonnummer i din profil."
    }
  }
}
